import { Pipe, PipeTransform } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Observable } from 'rxjs';

@Pipe({
    name: 'secure',
    standalone: false
})
export class SecurePipe implements PipeTransform {


  constructor(private http: HttpClient, private sanitizer: DomSanitizer) { }

  transform(url: string) {

    return new Observable<string>((observer) => {
      // This is a tiny blank image - ref: https://stackoverflow.com/a/49115219
      observer.next('data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==');

      // The next and error callbacks from the observer
      const {next, error} = observer;

      this.http.get(url, {responseType: 'blob'}).subscribe(response => {
        const reader = new FileReader();
        reader.readAsDataURL(response);
        reader.onloadend = function() {
          observer.next(reader.result.toString());
        };
      });

      return {unsubscribe() {  }};
    });
  }

}
